import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideLink from '../../components/GuideLink';
import GuideHeader from '../../components/GuideHeader';
import GuideSectionCallouts from '../../components/GuideSectionCallouts';

export default class ShouldIGrowMarijuana extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_2.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>  
          Jane's Guide to Gardening
        </h2>
        <p>
        Jane’s Guide to Gardening has all the information you need to grow marijuana. It is written for the curious individual looking to plant their first seed. It is focused on growing indoors in soil, although many of the principles will apply to other methods.
        </p>
        <h2>
        Should I Grow Marijuana?
        </h2>
        
        <p>
        Growing marijuana is an incredibly rewarding experience, however to do it right, you should be prepared to fully invest yourself into the process.  Before beginning your grow, ask yourself a few important questions. 
        </p>

        <div className="Guide__bullet">
          <div className="Guide__bullet__icon">
            <i className="fa fa-balance-scale fa-3x"></i> 
          </div>
          <p>
          <span className="highlight">Is home marijuana cultivation legal in my state?</span> Just because you live in a state where recreational marijuana is legal, you may not be allowed to grow it at home. If it is legal, you should review the laws for your state, as there is often strict rules regarding the number of plants you may grow. 
          </p>
        </div>

        <div className="Guide__bullet">
          <div className="Guide__bullet__icon">
            <i className="fa fa-cube fa-3x"></i> 
          </div>
          <p>
          <span className="highlight">Do I have the space to grow marijuana?</span> Growing marijuana requires more than just a pot beside the window. You’ll need a dedicated space for your plants. This can be inside or outside depending on your climate. 
          </p>
        </div>

        <div className="Guide__bullet">
          <div className="Guide__bullet__icon">
            <i className="fa fa-clock-o fa-3x"></i> 
          </div>
            <p>
            <span className="highlight">Do I have the time to grow marijuana?</span> Growing marijuana is a time and resource intense process. The entire growing process requires around six months of near daily attention to make sure your plants live a happy and fruitful life. 
            </p>
        </div>

        <div className="Guide__bullet">
          <div className="Guide__bullet__icon">
            <i className="fa fa-usd fa-3x"></i> 
          </div>
          <p>
          <span className="highlight">Do I have the money to grow marijuana?</span> The amount of tools and resources you’ll need to grow can quickly become overwhelming. There’s no magic number for how much you need to spend. A small, simple grow can be made for a couple hundred dollars, although expect to pay between $500 and $1000, if not more, during your first grow.
          </p>
        </div>

        <p>
        If the answer to all of these questions is yes, then it’s time to get started. <GuideLink slugTo="part-one-introduction" cta="New growers should start with Part I." />
        </p>
        <GuideSectionCallouts />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/should_i_grow_marijuana.js